import common from '@/components/survey/common/ui/styles/common.module.scss';

export const WhyNeedSpecialRelationship = () => {
  return (
    <section className={'pt-6'}>
      <h3 className={common.section_title}>특수관계인, 왜 확인이 필요한가요?</h3>
      <p className={common.section_list_item}>대표님과 특수관계인 직원이 확인되어야 정확한 환급 진행이 가능해요.</p>
    </section>
  );
};
